export function LineChartIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Line Chart"
    >
      <path
        d="M2.71875 3.08929C2.71875 2.76272 2.44707 2.5 2.10938 2.5C1.77168 2.5 1.5 2.76272 1.5 3.08929V11.5357C1.5 12.621 2.40898 13.5 3.53125 13.5H13.8906C14.2283 13.5 14.5 13.2373 14.5 12.9107C14.5 12.5842 14.2283 12.3214 13.8906 12.3214H3.53125C3.08184 12.3214 2.71875 11.9703 2.71875 11.5357V3.08929ZM13.5098 5.86384C13.7484 5.63304 13.7484 5.25982 13.5098 5.03147C13.2711 4.80313 12.8852 4.80067 12.649 5.03147L9.62754 7.95335L7.62168 6.01362C7.38301 5.78281 6.99707 5.78281 6.76094 6.01362L4.11523 8.56473C3.87656 8.79554 3.87656 9.16875 4.11523 9.3971C4.35391 9.62545 4.73984 9.6279 4.97598 9.3971L7.18496 7.26094L9.19082 9.20067C9.42949 9.43147 9.81543 9.43147 10.0516 9.20067L13.5098 5.86384Z"
        fill="currentColor"
      />
    </svg>
  );
}
